import { useEffect, useState } from "react";
import axios from "axios";
import { Spinner } from "@heroui/spinner";

export default function DividendRatios({ stockSymbol }) {
  // Initialize state variables for stock data
  const [dividendYielTTM, setDividendYielTTM] = useState("");
  const [dividendPerShareTTM, setDividendPerShareTTM] = useState("");
  const [dividendYielPercentageTTM, setDividendYielPercentageTTM] =
    useState("");
  const [
    dividendPaidAndCapexCoverageRatioTTM,
    setDividendPaidAndCapexCoverageRatioTTM,
  ] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchStockData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          "/api/company/ratios",
          { ticker: stockSymbol },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.status === 200) {
          throw new Error("Network response was not ok");
        }
        const data = await response.data;
        const stockInfo = data[0];
        setDividendYielTTM(Number(stockInfo.dividendYielTTM).toFixed(2));
        setDividendPerShareTTM(
          Number(stockInfo.dividendPerShareTTM).toFixed(2)
        );
        setDividendYielPercentageTTM(
          Number(stockInfo.dividendYielPercentageTTM).toFixed(2)
        );
        setDividendPaidAndCapexCoverageRatioTTM(
          Number(stockInfo.dividendPaidAndCapexCoverageRatioTTM).toFixed(2)
        );
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching stock data:", error);
        setIsLoading(false);
      }
    };

    fetchStockData();
  }, [stockSymbol]);

  // Loading condition
  if (
    isLoading &&
    !dividendYielTTM &&
    !dividendPerShareTTM &&
    !dividendYielPercentageTTM &&
    !dividendPaidAndCapexCoverageRatioTTM &&
    stockSymbol
  ) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spinner color="primary" />
      </div>
    );
  }

  if (
    !isLoading &&
    !dividendYielTTM &&
    !dividendPerShareTTM &&
    !dividendYielPercentageTTM &&
    !dividendPaidAndCapexCoverageRatioTTM
  ) {
    return (
      <div className="flex justify-center items-center h-full">
        Not available for this company.
      </div>
    );
  }

  return (
    <div>
      {/* Repeat the following structure for each line as needed */}

      <div className="flex mt-10 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{dividendYielTTM}</div>
      </div>
      <div className="text-left font-semibold text-sm">Dividen Yield TTM:</div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{dividendPerShareTTM}</div>
      </div>
      <div className="text-left font-semibold text-sm">
        Dividend Per Share TTM:
      </div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{dividendYielPercentageTTM}</div>
      </div>
      <div className="text-left font-semibold  text-sm">
        Dividen Yield % TTM:
      </div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">
          {dividendPaidAndCapexCoverageRatioTTM}
        </div>
      </div>
      <div className="text-left font-semibold  text-sm">
        Dividend Paid and Capex Cover. TTM:
      </div>
    </div>
  );
}
